import { MdOndemandVideo } from "react-icons/md";

export default function MentorApplicationStepThree({setApplicationState, applicationPiece}) {
  function handleChange(e) {
    setApplicationState(prev => ({...prev, stepThree: {courseCategory: e.target.value}}))
  }
  return (
    <div className="mentor-app-content">
      <h1>What category best fits the knowledge you'll share?</h1>
      <p style={{color:"gray", marginBlockStart:"12px", marginBlockEnd:"50px", fontSize:"16px"}}>If you're not sure about the right category, you can change it later.</p>
      <select onChange={handleChange} value={applicationPiece.courseCategory}>
        <option value={""}>Choose a category</option>
        <option value={"Development"}>Development</option>
        <option value={"Business"}>Business</option>
        <option value={"Finance & Accounting"}>Finance & Accounting</option>
        <option value={"IT & Software"}>IT & Software</option>
        <option value={"Design"}>Design</option>
        <option value={"Marketing"}>Marketing</option>
        <option value={"Teaching & Academics"}>Teaching & Academics</option>
        <option value={"unsure"}>I don't know yet</option>
      </select>
    </div>
  )
}